/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-09-10
 */

import { Injectable } from '@angular/core';
import { API_CONFIG, BaseCrudService } from '@nebula-shared/data-access';
import { Bank } from '../../domain/bank-entity.model';
@Injectable({ providedIn: 'root' })
export class BankService extends BaseCrudService<Bank> {
  constructor() {
    super();
    const config = API_CONFIG.accounting;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.terceros}`);
  }

  /**
   * Ruta del page-response de vinculos de terceros, la que consulta la ventana de busqueda de
   * maestros con el filtro fijo de entidad bancaria; el servidor pagina, busca y ordena.
   *
   * @returns la ruta completa del page-response de vinculos de terceros
   */
  get rutaDePageResponse(): string {
    return `${this.baseUrl}/page-response-vinculo`;
  }
}
